export default __webpack_public_path__ + "static/media/user-spine.f7bff7c1.svg";